import React from 'react';

const WhoAreWe = () => (
  <div className="bg-gray-50 overflow-hidden">
    <div className="max-w-xl mx-auto  lg:max-w-screen-xl">
      <div className="relative max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <svg
          className="absolute top-0 left-full transform -translate-x-1/2 -translate-y-3/4 lg:left-auto lg:right-full lg:translate-x-2/3 lg:translate-y-1/4"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
        >
          <defs>
            <pattern
              id="8b1b5f72-e944-4457-af67-0c6d15a99f38"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                className="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#8b1b5f72-e944-4457-af67-0c6d15a99f38)"
          />
        </svg>

        <div className="relative lg:grid lg:grid-cols-3 lg:col-gap-8">
          <div className="lg:col-span-1">
            <h3 className="text-3xl leading-9 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              How it works
            </h3>
          </div>
          <div className="mt-10 sm:grid sm:grid-cols-1 sm:col-gap-8 sm:row-gap-10 lg:col-span-2 lg:mt-0">
            <div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-gray-900">
                  Customer App
                </h5>
                <p className="mt-2 text-base leading-6 text-gray-500">
                  Your customers go onto the app and purchase what they want
                </p>
              </div>
            </div>
            <div className="mt-10 sm:mt-0">
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-gray-900">
                  Process the order
                </h5>
                <p className="mt-2 text-base leading-6 text-gray-500">
                  You see the order and prepare it
                </p>
              </div>
            </div>
            <div className="mt-10 sm:mt-0">
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-gray-900">
                  Deliver the order
                </h5>
                <p className="mt-2 text-base leading-6 text-gray-500">
                  You deliver the order to the customer
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WhoAreWe;
